import { render, staticRenderFns } from "./ProductFieldAddComment.vue?vue&type=template&id=6443c152&"
import script from "./ProductFieldAddComment.vue?vue&type=script&lang=js&"
export * from "./ProductFieldAddComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports